import moment from 'moment-timezone'
import { PropsWithChildren, FC } from 'react'
import { DATE_FORMATS } from '@ProdWb/constants'

import Box from '~/core/Box'
import Text from '~/core/Text'
import styles from '../styles.css'

import { ProgressBarParameters, ProgressDataType } from './types'
import { MILESTONE_MISSED, MILESTONE_NOT_REACHED } from './constants'

type DescriptionContentPropsType = {
    description: ProgressDataType
    stages: ProgressBarParameters
}

const DescriptionContent: FC<
    PropsWithChildren<DescriptionContentPropsType>
> = props => {
    const { description, stages } = props
    const { porDate, committedDate, actualDate } = description
    const { isDelayed } = stages

    return (
        <Box direction="col" style={{ fontSize: '11px' }}>
            {committedDate && (
                <Text>
                    {`Committed: ${moment(committedDate)
                        .tz(moment.tz.guess())
                        .format(
                            DATE_FORMATS.YEAR_FIRST_DATE_WITHOUT_COMMA_SEP_FORMAT,
                        )}`}
                </Text>
            )}
            {porDate && (
                <Text style={{ paddingLeft: '16%' }}>
                    {`POR: ${moment(porDate)
                        .tz(moment.tz.guess())
                        .format(
                            DATE_FORMATS.YEAR_FIRST_DATE_WITHOUT_COMMA_SEP_FORMAT,
                        )}
                    `}
                </Text>
            )}
            {actualDate && (
                <Text
                    className={
                        isDelayed
                            ? styles.warningDisplayContent
                            : styles.succeeDisplayContent
                    }
                    style={{ paddingLeft: '13%' }}
                >
                    {`Actual: ${moment(actualDate)
                        .tz(moment.tz.guess())
                        .format(
                            DATE_FORMATS.YEAR_FIRST_DATE_WITHOUT_COMMA_SEP_FORMAT,
                        )}`}
                </Text>
            )}
            {!actualDate &&
                committedDate &&
                moment(moment()).isBefore(committedDate) && (
                    <Text className={styles.warningDisplayContent}>
                        {MILESTONE_NOT_REACHED}
                    </Text>
                )}
            {!actualDate &&
                committedDate &&
                moment(moment()).isAfter(committedDate) && (
                    <Text className={styles.warningDisplayContent}>
                        {MILESTONE_MISSED}
                    </Text>
                )}
        </Box>
    )
}

export default DescriptionContent
